import { callSentryWithFirebaseError } from 'utils/sentry/call-sentry-with-firebase-error'

interface CancellationFeedback {
  userId: string
  email: string
  timestamp: number
  feedback: string
}

export const saveCancellationFeedback = async (feedbackData: CancellationFeedback): Promise<void> => {
  const fireDb = await import('firebase/database')
  const { getDatabase, ref, push } = fireDb

  // Create a reference to the premiumCancellationFeedback path
  const feedbackRef = ref(getDatabase(), 'premiumCancellationFeedback')

  // Push the feedback data to create a new entry with auto-generated key
  push(feedbackRef, feedbackData).catch(callSentryWithFirebaseError)
}
